(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["list-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.lb'); if (!root) return;
    var KEY = 'mega-list-builder-v1';
    var $ = function (id) { return document.getElementById(id); };
    var state = { items: [] };
    try { var saved = JSON.parse(localStorage.getItem(KEY) || 'null'); if (saved && saved.items) state = saved; } catch (e) {}
    var fields = ['lb-school','lb-school-other','lb-year','lb-subject','lb-name','lb-email','lb-students','lb-notes'];
    fields.forEach(function (f) { var el = $(f); if (el && state[f] != null) el.value = state[f]; el && el.addEventListener('input', save); el && el.addEventListener('change', save); });
    $('lb-school').addEventListener('change', function () { $('lb-school-other-wrap').hidden = this.value !== '__other'; });
    $('lb-school-other-wrap').hidden = $('lb-school').value !== '__other';
    function money(n) { return '$' + (Math.round(n * 100) / 100).toFixed(2); }
    function save() { fields.forEach(function (f) { var el = $(f); if (el) state[f] = el.value; }); try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) {} }
    function render() {
      var body = $('lb-body'); body.innerHTML = '';
      if (!state.items.length) { body.innerHTML = '<tr class="lb__empty"><td colspan="5">Nothing yet. Search and add items on the left.</td></tr>'; }
      var total = 0;
      state.items.forEach(function (it, i) {
        total += it.price * it.qty;
        var tr = document.createElement('tr');
        tr.innerHTML = '<td>' + it.title + '</td><td class="lb__num"><input type="number" min="1" max="99" value="' + it.qty + '" data-i="' + i + '"></td><td class="lb__num">' + money(it.price) + '</td><td class="lb__num">' + money(it.price * it.qty) + '</td><td><button type="button" class="lb__rm" data-rm="' + i + '" aria-label="Remove">&times;</button></td>';
        body.appendChild(tr);
      });
      $('lb-total').textContent = money(total);
      save();
    }
    $('lb-body').addEventListener('input', function (e) { var i = e.target.getAttribute('data-i'); if (i != null) { state.items[i].qty = Math.max(1, parseInt(e.target.value || '1', 10)); render(); } });
    $('lb-body').addEventListener('click', function (e) { var i = e.target.getAttribute('data-rm'); if (i != null) { state.items.splice(i, 1); render(); } });
    function add(p) {
      var ex = state.items.find(function (x) { return x.handle === p.handle; });
      if (ex) ex.qty += 1; else state.items.push({ handle: p.handle, title: p.title, price: p.price, sku: p.sku, qty: 1 });
      render(); toast('Added');
    }
    var t; $('lb-q').addEventListener('input', function () { clearTimeout(t); var q = this.value.trim(); if (q.length < 2) { $('lb-results').innerHTML = ''; return; } t = setTimeout(function () { search(q); }, 220); });
    function search(q) {
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=hide')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var list = (d.resources && d.resources.results && d.resources.results.products) || [];
          var ul = $('lb-results'); ul.innerHTML = '';
          if (!list.length) { ul.innerHTML = '<li class="lb__hint">No match. Try fewer words, or add it to the notes.</li>'; return; }
          list.forEach(function (p) {
            if ((p.tags || []).indexOf('pack') !== -1) return;
            var li = document.createElement('li'); li.className = 'lb__result';
            var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
            var price = parseFloat(p.price);
            li.innerHTML = (img ? '<img src="' + img + '&width=88" alt="">' : '<span></span>') + '<span class="lb__result-name">' + p.title + '</span><span class="lb__result-price">' + money(price) + '</span><button type="button" class="lb__add">Add</button>';
            li.querySelector('.lb__add').addEventListener('click', function () { add({ handle: p.handle, title: p.title, price: price, sku: (p.variants && p.variants[0] && p.variants[0].sku) || '' }); });
            ul.appendChild(li);
          });
        }).catch(function () {});
    }
    function meta() {
      var school = $('lb-school').value === '__other' ? $('lb-school-other').value : $('lb-school').value;
      return { school: school, year: $('lb-year').value, subject: $('lb-subject').value, name: $('lb-name').value, email: $('lb-email').value, students: $('lb-students').value, notes: $('lb-notes').value };
    }
    function csv() {
      var m = meta(); var rows = [['School', m.school], ['Year level', m.year], ['Class/subject', m.subject], ['Teacher', m.name], ['Email', m.email], ['Students', m.students], [], ['SKU', 'Item', 'Qty per student', 'Price each (inc GST)', 'Line']];
      state.items.forEach(function (it) { rows.push([it.sku, it.title, it.qty, it.price.toFixed(2), (it.price * it.qty).toFixed(2)]); });
      rows.push([], ['', 'Cost per student', '', '', state.items.reduce(function (a, b) { return a + b.price * b.qty; }, 0).toFixed(2)], [], ['Notes', m.notes]);
      return rows.map(function (r) { return r.map(function (c) { return '"' + String(c == null ? '' : c).replace(/"/g, '""') + '"'; }).join(','); }).join('\n');
    }
    $('lb-csv').addEventListener('click', function () {
      var m = meta(); var blob = new Blob([csv()], { type: 'text/csv' }); var a = document.createElement('a'); a.href = URL.createObjectURL(blob);
      a.download = ('Booklist ' + (m.school || 'school') + ' ' + m.year + '.csv').replace(/[^\w\- .]/g, ''); a.click();
    });
    $('lb-send').addEventListener('click', function () {
      var m = meta();
      if (!m.school || !m.name || !m.email) { toast('Add your school, name and email first'); return; }
      if (!state.items.length) { toast('Add at least one item'); return; }
      var lines = state.items.map(function (it) { return it.qty + ' x ' + it.title + ' (' + it.sku + ') @ ' + money(it.price); });
      var total = state.items.reduce(function (a, b) { return a + b.price * b.qty; }, 0);
      var body = 'School: ' + m.school + '\nYear level: ' + m.year + '\nClass/subject: ' + m.subject + '\nTeacher: ' + m.name + '\nEmail: ' + m.email + '\nStudents: ' + m.students + '\n\nITEMS (per student)\n' + lines.join('\n') + '\n\nCost per student: ' + money(total) + '\n\nNotes:\n' + m.notes + '\n\n(Sent from megaschoolsupplies.com.au list builder)';
      var subject = 'Booklist: ' + m.school + ' - ' + m.year + (m.subject ? ' - ' + m.subject : '');
      window.location.href = 'mailto:{{ section.settings.send_to }}?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
      toast('Opening your email app. The CSV is a good backup — download it too.');
    });
    $('lb-clear').addEventListener('click', function () { if (confirm('Clear this list?')) { state = { items: [] }; fields.forEach(function (f) { var el = $(f); if (el) el.value = ''; }); render(); } });
    function toast(msg) { var el = document.createElement('div'); el.className = 'lb__toast'; el.textContent = msg; document.body.appendChild(el); setTimeout(function () { el.remove(); }, 2200); }
    render();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pack-extras"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('.px'); if (!root) return;
    function toast(msg) { var el = document.createElement('div'); el.className = 'px__toast'; el.textContent = msg; document.body.appendChild(el); setTimeout(function () { el.remove(); }, 2000); }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('.px__add'); if (!b || b.disabled) return;
      var vid = b.getAttribute('data-vid'); b.disabled = true; b.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: 1 }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          b.textContent = 'Added ✓'; b.classList.add('is-added'); b.disabled = false; toast('Added to your order');
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
            document.querySelectorAll('[data-cart-count], .cart-count, .header__cart-count').forEach(function (n) { n.textContent = c.item_count; });
          }).catch(function () {});
        })
        .catch(function () { b.textContent = 'Try again'; b.disabled = false; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["school-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.sf').forEach(function (root) {
      var id = root.id.replace('sf-', '');
      var input = document.getElementById('sf-input-' + id);
      var grid = document.getElementById('sf-grid-' + id);
      var empty = document.getElementById('sf-empty-' + id);
      var count = document.getElementById('sf-count-' + id);
      if (!input || !grid) return;
      var tiles = Array.prototype.slice.call(grid.querySelectorAll('.sf__tile'));
      var live = tiles.filter(function (t) { return !t.classList.contains('sf__tile--ask') && !t.classList.contains('is-coming'); }).length;
      if (count) count.textContent = live >= 3 ? live + ' schools live' : '';
      function filter() {
        var q = input.value.trim().toLowerCase();
        var shown = 0;
        tiles.forEach(function (t) {
          var hit = !q || (t.getAttribute('data-name') || '').indexOf(q) !== -1;
          t.hidden = !hit;
          if (hit && !t.classList.contains('sf__tile--ask')) shown++;
        });
        if (empty) empty.hidden = shown > 0 || !q;
      }
      input.addEventListener('input', filter);
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          var first = tiles.find(function (t) { return !t.hidden && !t.classList.contains('sf__tile--ask'); });
          if (first) { e.preventDefault(); window.location.href = first.getAttribute('href'); }
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
